import React from 'react';
import { useRouter } from '../../../../hooks/router';
import { UiFlex } from '@open-stack/ui';
import { XTextTitle } from '../../text/XTextTitle';
import { XButton } from '../../button/XButton';

interface Props {
    title?: any;
    backButtonTo?: any;
    backButtonOnClick?: any;
    children?: any;
}

export function XPageHeader({ title, backButtonTo, backButtonOnClick, children }: Props) {
    const { goBack } = useRouter();

    return (
        <UiFlex padding={1} justifyContent="space-between" gap={2}>
            <UiFlex gap={1}>
                <XButton
                    to={backButtonTo}
                    onClick={() => {
                        if (backButtonOnClick) {
                            backButtonOnClick();
                        } else if (!backButtonTo) {
                            goBack();
                        }
                    }}
                    icon="arrow_back"
                    variant="text"
                />

                <XTextTitle>{title}</XTextTitle>
            </UiFlex>

            <UiFlex>{children}</UiFlex>
        </UiFlex>
    );
}
